module.exports = __webpack_public_path__ + "img/shipo-menu-facility-checklist-performance-white.d2bebaf3.svg";